import type { ClassNamesConfig } from 'react-select';
import Select from 'react-select';

export interface ISelectedOption {
  value: string;
  label: string;
}

interface SelectFieldProps {
  isDisabled?: boolean;
  value: ISelectedOption | null;
  options: ISelectedOption[];
  placeholder?: string;
  onChange: (newValue: ISelectedOption | null) => void;
  className?: string;
  minWidth?: string;
  classNames?: ClassNamesConfig<ISelectedOption, false>;
  menuPosition?: 'absolute' | 'fixed';
}

const SelectField: React.FC<SelectFieldProps> = ({
  isDisabled = false,
  value,
  options,
  placeholder,
  onChange,
  className = '',
  minWidth = '15em',
  classNames,
  menuPosition = 'absolute',
}) => {
  const defaultClassNames = {
    menuList: () => `min-w-[${minWidth}]`,
  };

  const mergedClassNames = classNames ? { ...defaultClassNames, ...classNames } : defaultClassNames;

  return (
    <div className={`custom-select z-[1000] min-w-[${minWidth}] ${className}`}>
      <Select
        classNames={mergedClassNames}
        isDisabled={isDisabled}
        value={value}
        options={options}
        placeholder={placeholder}
        onChange={onChange}
        classNamePrefix='custom-select'
        menuPosition={menuPosition}
        // In fixed mode (used inside modals) portal to <body> so the menu escapes
        // the modal's overflow/transform and anchors under the field; the raised
        // z-index keeps it above the modal stack. Absolute mode is left untouched.
        menuPortalTarget={
          menuPosition === 'fixed' && typeof document !== 'undefined' ? document.body : undefined
        }
        styles={{
          menu: (provided) => ({
            ...provided,
            width: 'max-content',
            minWidth: '100%',
            zIndex: 1000,
          }),
          menuPortal: (provided) => ({
            ...provided,
            zIndex: 20000,
          }),
        }}
      />
    </div>
  );
};

export default SelectField;
